export default hashid => (
  window.open(`${process.env.API_LOCATION}/delivery_notes/${hashid}/pdf/download/?token=${localStorage.getItem('id_token')}`)
);



// WEBPACK FOOTER //
// ./src/app/services/invoice/downloadDeliveryNote.js